import { generateMeasuresFromDimensions } from './generate-measures.js';
import { departmentLink, legislativeItemLink, meetingBodyLink } from './links.js';
import { legislativeItemSystemStatusValueLabels } from './value-labels.js';
const aggregatableDimensions = {
    'legislative_document_tracker.attachment_count': {
        aggregations: ['avg', 'sum'],
        label: 'Attachment Count',
        type: 'number',
    },
    'legislative_document_tracker.document_count': {
        aggregations: ['sum'],
        label: 'Document Count',
        type: 'number',
    },
};
/**
 * Combination data source: Agenda Items x Documents.
 * Attachment completeness and document metrics per legislative item. Answers whether
 * items have required staff reports and supporting materials before agenda publication.
 */
export const legislativeDocumentTrackerCube = {
    category: 'Documents',
    description: 'Document and attachment completeness for legislative items including staff reports and supporting materials.',
    label: 'Legislative Document Completeness',
    requiredModule: 'hasAgenda',
    measures: {
        'legislative_document_tracker.count': { label: 'Count', type: 'number' },
        ...generateMeasuresFromDimensions(aggregatableDimensions),
    },
    dimensions: {
        ...aggregatableDimensions,
        // Legislative Item
        'legislative_items.code': { label: 'Item Number', link: legislativeItemLink, type: 'string' },
        'legislative_items.full_title': {
            label: 'Item Title',
            link: legislativeItemLink,
            type: 'string',
        },
        'legislative_items.status': {
            label: 'System Status',
            type: 'string',
            valueLabels: legislativeItemSystemStatusValueLabels,
        },
        // Status & Type
        'legislative_statuses.name': { label: 'Public Meeting Status', type: 'string' },
        'legislative_types.name': { label: 'Item Type', type: 'string' },
        // Document Metrics
        'legislative_document_tracker.has_staff_report': {
            label: 'Has Staff Report',
            type: 'boolean',
        },
        // Context
        'departments.name': { label: 'Department', link: departmentLink, type: 'string' },
        'meeting_bodies.name': { label: 'Meeting Body', link: meetingBodyLink, type: 'string' },
    },
    timeDimensions: {
        'legislative_items.created_at': { label: 'Item Created At', type: 'date' },
        'legislative_items.target_meeting_date': { label: 'Target Meeting Date', type: 'date' },
    },
};
